import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-init',
  templateUrl: './password-reset-init.component.html',
  styleUrls: ['./password-reset-init.component.scss']
})
export class PasswordResetInitComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
